export interface Partner {
  name: string;
  org: string;
  logo: string;
  socials: {
    website?: string;
    instagram?: string;
    instagram2?: string;
    youtube?: string;
    linkedin?: string;
    facebook?: string;
  };
}
export const partners = [
  {
    name: "Teach for Indonesia Student Community",
    org: "BINUS University",
    logo: "/images/partners/tfi.png",
    socials: {
      website: "https://student-activity.binus.ac.id/tfi/",
      instagram: "https://www.instagram.com/tfistudentcommunity/",
      youtube: "https://www.youtube.com/@TFIStudentCommunity",
      linkedin: "https://id.linkedin.com/company/tfi-student-community-tfisc",
    },
  },
  {
    name: "Bina Nusantara Computer Club",
    org: "BINUS University",
    logo: "/images/partners/bncc.png",
    socials: {
      website: "https://bncc.net",
      instagram: "https://www.instagram.com/bnccbinus/",
      instagram2: "https://www.instagram.com/bnccalsut/",
      facebook: "https://www.facebook.com/bina.nusantara.computer.club/",
      linkedin: "https://www.linkedin.com/company/bina-nusantara-computer-club/mycompany/",
    },
  },
  {
    name: "Accelist Edukasi Indonesia",
    org: "Accelist Lentera Indonesia",
    logo: "/images/partners/aei.png",
    socials: {
      website: "https://edukasi.accelist.com/",
      instagram: "https://instagram.com/accelistedukasi.indonesia",
      facebook: "https://www.facebook.com/profile.php?id=100092659237819",
      linkedin: "https://www.linkedin.com/company/accelist-edukasi-indonesia/",
    },
  },
];